import { useEffect } from "react"

import useCurrentViewType from "@hooks/useCurrentViewType"
import useLocalStorage from "@hooks/useLocalStorage"

import { ObjectsViewType } from "@organisms/ObjectsView/ObjectsView.types"

import { ViewTypesProviderContext } from "./ViewTypesProvider.context"
import { ViewTypesProviderProps } from "./ViewTypesProvider.types"

// The cards view type was persisted as "card" before it was pluralized. Stored values are rewritten on mount so
// this mapping can be dropped once existing users have loaded a list page.
const LEGACY_VIEW_TYPES: Record<string, ObjectsViewType> = { card: "cards" }

export default function ViewTypesProvider(props: ViewTypesProviderProps) {
    const { children, viewTypes, viewTypeKey, defaultViewType } = props
    const [storedViewType, setActiveViewType] = useLocalStorage<ObjectsViewType>(viewTypeKey, defaultViewType)
    const activeViewType = LEGACY_VIEW_TYPES[storedViewType] ?? storedViewType

    const { setCurrentViewType } = useCurrentViewType()

    useEffect(() => {
        if (storedViewType !== activeViewType) {
            setActiveViewType(activeViewType)
        }
    }, [storedViewType])

    useEffect(() => {
        setCurrentViewType(activeViewType)
    }, [activeViewType])

    return (
        <ViewTypesProviderContext.Provider value={{ viewTypes, activeViewType, setActiveViewType }}>
            {children({ activeViewType })}
        </ViewTypesProviderContext.Provider>
    )
}
